module.exports = __webpack_public_path__ + "assets/images/boundaries/comparison/2020/desktop_old.svg?v=93c9986c";